import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import DownloadPage from './pages/DownloadPage';
import HomePage from './pages/HomePage';
import ReferralPage from './pages/ReferralPage';
import AdminPage from './pages/AdminPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/download" element={<DownloadPage />} />
        <Route path="/ref/:referralCode" element={<ReferralPage />} />
        <Route path="/:referralCode" element={<ReferralPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
